import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Grid from '@mui/material/Grid';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { tutorDashboardCardMapper } from '../utils/tutorCardMapper';
import { Link } from 'react-router-dom';
import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import GlobalSelectFieldWithoutFormik from '../../../../components/mui/GlobalSelectFieldWithoutFormik';
import FromAndToDatePicker from '../../../../components/mui/FromAndToDatePicker';
import dayjs from 'dayjs';
import { useDispatch } from 'react-redux';
import { getTutorDashboardMainCards } from '../../../../redux/features/CRDslice';
import TutorSlotUtilizationTable from './TutorSlotUtilizationTable';

const TutorManagementCardAndTable = () => {
  const [fromDate, setFromDate] = useState(dayjs().startOf('month').format('YYYY-MM-DD'));
  const [toDate, setToDate] = useState(dayjs().endOf('month').format('YYYY-MM-DD'));
  const [project, setProject] = useState({ id: -1, value: 'All' });
  const allProject = useSelector((state) => state.course.projects);
  const tutorDashboardCards = useSelector((state) => state?.crd.tutorDashboardMainCard?.data);
  const tutorDashboardCardsLoading = useSelector((state) => state?.crd.tutorDashboardMainCard?.loading);
  const dispatch = useDispatch();

  const dispatchParams = useMemo(
    () => ({
      fromDate,
      toDate,
      project_id: project?.id === -1 ? null : project?.id,
    }),
    [fromDate, toDate, project],
  );

  useEffect(() => {
    dispatch(getTutorDashboardMainCards(dispatchParams));
  }, [dispatchParams, dispatch]);

  return (
    <Stack>
      <Stack direction={{ xs: 'column', sm: 'row' }} gap={1} mb={2} maxWidth={700}>
        <FromAndToDatePicker
          {...{ fromDate, toDate, setFromDate, setToDate }}
          fullWidth
          containerStyle={{ width: '100%' }}
        />
        <GlobalSelectFieldWithoutFormik
          data={[{ id: -1, name: 'All Project' }, ...allProject]}
          label={'Project'}
          setChange={setProject}
          keys={{ itemId: 'id', itemValue: 'name' }}
          selectedDetails={project}
          sx={{ width: '100%' }}
          disabled={!Boolean(allProject?.length)}
        />
      </Stack>

      <Grid container spacing={2}>
        {tutorDashboardCardMapper.map(({ icon, iconBgColor, id, title, value, noInfo, type }) => (
          <Grid item key={id} xs={12} sm={6} md={3} lg={2.4}>
            {tutorDashboardCardsLoading ? (
              <Skeleton
                sx={{
                  minWidth: { xs: '100%', sm: 200 },
                  width: '100%',
                  borderRadius: 2,
                  p: 2,
                  minHeight: 150,
                }}
              />
            ) : (
              <Card
                sx={{
                  minWidth: { xs: '100%', sm: 200 },
                  width: '100%',
                  borderRadius: 2,
                  border: '0.5px solid #e6e6e6ff',
                  p: 2,
                  minHeight: 145,
                }}
              >
                <CardContent
                  sx={{
                    p: 0,
                    '&:last-child': {
                      pb: 0,
                    },
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 1,
                  }}
                >
                  <Box display="flex" justifyContent="space-between" alignItems="flex-start">
                    <Box
                      sx={{
                        width: 40,
                        height: 40,
                        borderRadius: 1,
                        backgroundColor: iconBgColor,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        mb: 1,
                      }}
                    >
                      {icon}
                    </Box>

                    {!noInfo && (
                      <Link
                        to={{
                          pathname: 'card-tutor-info',
                          search: `?${new URLSearchParams({ fromDate, toDate, project: project?.id, type }).toString()}`,
                        }}
                      >
                        <IconButton size="small">
                          <InfoOutlinedIcon fontSize="small" />
                        </IconButton>
                      </Link>
                    )}
                  </Box>

                  <Typography
                    sx={{
                      color: 'text.secondary',
                      fontSize: 14,
                      fontWeight: 500,
                    }}
                  >
                    {title}
                  </Typography>

                  <Typography
                    sx={{
                      fontSize: 21,
                      fontWeight: 700,
                      color: '#111827',
                    }}
                  >
                    {`${tutorDashboardCards?.[value] ?? '-'}`}
                  </Typography>
                </CardContent>
              </Card>
            )}
          </Grid>
        ))}
      </Grid>
      <TutorSlotUtilizationTable fromDate={fromDate} toDate={toDate} project={project?.id} />
    </Stack>
  );
};
export default React.memo(TutorManagementCardAndTable);
